/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Externaltemperature1Inputs */



/**
* | output |
* | --- |
* | "External temperature" |
*
* @param {Br_History_Key_Externaltemperature1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_externaltemperature1 = /** @type {((inputs?: Br_History_Key_Externaltemperature1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Externaltemperature1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("External temperature")
	return /** @type {LocalizedString} */ ("Température extérieure")
});
export { br_history_key_externaltemperature1 as "br_history_key_externalTemperature" }